import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { MaterialRequestEntity } from "./material-request-entity";
import { StockInEntity } from "../stock-in/entities/stock-in.entity";
import { MachineEntity } from "../machine/entities/machine-entity";
import { NeedleSizes } from "../needle-sizes/needle-sizes-entity";
import { PointTypesEntity } from "../point-type/entities/point-type-entity";
import { NeedleModelEntity } from "../masters/needle-model/entity/needle-model-entity";
import { StockOutEntity } from "../stock-in/entities/stock-out.entity";


@Injectable()
export class MaterialRequestRepository extends Repository<MaterialRequestEntity> {

    constructor(@InjectRepository(MaterialRequestEntity) private MaterialRequestEntityRepo: Repository<MaterialRequestEntity>
    ) {
        super(MaterialRequestEntityRepo.target, MaterialRequestEntityRepo.manager, MaterialRequestEntityRepo.queryRunner);
    }

    //  async getCurrencydrop(): Promise<any[]> {
    //     const query = this.createQueryBuilder('rmi')
    //     .select(`rm_item_id, currency_name AS currency`)
    //     .leftJoin(Currencies, 'c','c.currency_id = rmi.currency_id')
    //    // .where('1=1'); 
    //    .groupBy('c.currency_name')

    //     let data:RmCreationEntity[] = await query.getRawMany();
    //     return data;
    //   }
    

    async getMaterialRequest():Promise<any[]>{
        const query = this.createQueryBuilder('mr')
        .select(`mr.module,mr.material_req_id AS id,
            mr.needle_point_id as needlePointId,
            mr.needle_size_id as needleSizeId,
            mr.needle_model_id as needleModelId,
            mr.shift,
            mr.needle_Quantity as needleQty,
            mr.purpose,
            m.machine_type as machineType ,
            m.machine,
            st.model_id as modelId,
            st.point_type_id as pointTypeId,
            st.size_id as sizeId,
            st.quantity,
            st.issued_quantity AS issuedQuantity,
            st.quantity-st.issued_quantity AS availableQty,
            mr.status,
            nm.needle_model as needleModel,
            ns.needle_sizes as needleSize,mr.date,(mr.needle_Quantity-IF(SUM(sto.issued_quantity) IS NOT NULL,SUM(sto.issued_quantity),0 )) AS pendingQty,SUM(sto.issued_quantity) AS issuedQty,
            p.point_type as pointType`)
        .leftJoin(StockInEntity, 'st','st.model_id = mr.needle_model_id and mr.needle_point_id = st.point_type_id and mr.needle_size_id = st.size_id')
        .leftJoin(MachineEntity, 'm','m.id = mr.machine_id')
        .leftJoin(NeedleSizes, 'ns','ns.id = mr.needle_size_id')
        .leftJoin(PointTypesEntity, 'p','p.id = mr.needle_point_id')
        .leftJoin(NeedleModelEntity, 'nm','nm.id = mr.needle_model_id')
        .leftJoin(StockOutEntity, 'sto','sto.request_id = mr.material_req_id')

        .orderBy("mr.date",'DESC')


          return query.getRawMany() 
    }

}